export const SHORT_DESCRIPTION_MAX = 120

export const DEVELOPER_DOCS_URL = import.meta.env.REACT_APP_DOCS_URL

export const MCP_KNOWLEDGEBASE_URL = 'https://help.zocks.io/en/articles/15331595-zocks-mcp-server-knowledge-base'

export const INTEGRATIONS_CONTACT_EMAIL = 'integrations@zocks.io'

// Scopes that cannot be self-selected and require contacting the integrations team.
export const CONTACT_REQUIRED_SCOPE_IDS = ['file:download']

// User-facing descriptions for the OAuth2 scope picker, keyed by scope id.
// Overrides the terser descriptions returned by the IAM permissions endpoint so
// the picker reads consistently. Falls back to the API description for any scope
// not listed here.
export const SCOPE_DESCRIPTIONS: Record<string, string> = {
  // Contacts
  'ext_user:list': 'List your Zocks contacts',
  'ext_user:read': 'View full contact profiles',
  'ext_user:create': 'Create new contacts',
  // Users
  'user:list': 'List team members',
  'user:read': 'View team member profiles',
  // Meetings
  'room:read': 'View meeting room details',
  'room_session:list': 'List meetings',
  'room_session:read': 'View meeting details and metadata',
  // Results
  'airesult:list': 'List AI results for a meeting',
  'airesult:read': 'View full AI result content',
  'ai_agent_result:list': 'List AI agent results',
  'ai_agent_result:read': 'View full AI agent output',
  'ai_agent:read': 'View AI agent details',
  'aifeature:read': 'View AI feature details',
  'aifeature:list': 'List AI features',
  // Meeting templates
  'meeting_template:list': 'List meeting templates',
  'meeting_template:read': 'View meeting template details',
  // Tasks
  'task:list': 'List meeting tasks',
  'task:read': 'View task details',
  // Transcripts
  'file:download': 'Download transcripts',
}

export const getScopeDescription = (scopeId: string, fallback: string): string => SCOPE_DESCRIPTIONS[scopeId] ?? fallback
